import axios from "axios";

const baseUrl = '/api/menu';

export const getMenuItems = () => axios.get(baseUrl)
